import { createFileRoute } from '@tanstack/react-router';

import ActionButton from '@/components/Button/ActionButton';
import { HStack, VStack } from '@/components/Layout';
import { ViewportLoader } from '@/components/Loading/ViewportLoader';
import { defaultNS, useTranslation } from '@/lib/i18n';

import { OperationPackageIndividualContainer } from './-components/operation-package';
import { useGetSelfServiceTask } from './-query';

export const Route = createFileRoute('/_individual/individual/task/$id/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'individualPages.tasks',
  });
  const { id } = Route.useParams();
  const navigate = Route.useNavigate();
  const { data, isLoading, error } = useGetSelfServiceTask(id);

  if (isLoading) {
    return <ViewportLoader />;
  }
  if (error) {
    return <div>{error.message}</div>;
  }
  if (!data) {
    return <></>;
  }

  return (
    <VStack className="px-5 py-4 gap-2 bg-neutral-fill min-h-full max-w-dialog-lg mx-auto w-full">
      <HStack className="justify-between">
        <HStack className="items-center">
          <ActionButton
            icon="ChevronLeft"
            variant="mutedGhost"
            size="sm"
            className="ml-[-8px]"
            onClick={() => {
              navigate({ to: '/individual' });
            }}
          >
            {t('navigateToHome')}
          </ActionButton>
        </HStack>
      </HStack>
      <OperationPackageIndividualContainer id={id} data={data} />
    </VStack>
  );
}
